





























































































































































































































import { Component, Vue, Ref, Watch } from 'vue-property-decorator'
import Chart from '@/components/Chart/index.vue'
import { classroomList, classroomAuthList } from '@/api/teachingProtection/teachManage'
import { attendanceStatic, attendanceRecordExport, absenceExport } from '@/api/teachingProtection/attendanceManage'

@Component({
  name: 'static',
  components: {
    Chart
  }
})
export default class extends Vue {
  private staticTime: (string | number)[] = [Date.now(), Date.now()]; // 统计时间
  private recordTime: (string | number)[] = [Date.now(), Date.now()]; // 记录时间
  private staticForm: any = {
    fromThroughGateTime: Date.now(),
    toThroughGateTime: Date.now(),
    classroomIds: []

  };
  private recordForm: any = {
    fromThroughGateTime: Date.now(),
    toThroughGateTime: Date.now(),
    classroomId: '',
    recordStatus: '',
    studentName: '',
    throughGateState: '',
    throughGateType: ''

  };
  private dialogForm:any = {
    studentId: '',
    recordTime: ''

  }
  private classList:any = [] // 班级
  private series:any = [
    {
      name: '已签到-在园',
      type: 'bar',
      stack: '记录',
      barMaxWidth: 60, // 最大宽度
      data: []
    },
    {
      name: '已签到-出园',
      type: 'bar',
      stack: '记录',
      barMaxWidth: 60, // 最大宽度
      data: []
    },
    {
      name: '未签到',
      type: 'bar',
      stack: '记录',
      barMaxWidth: 60, // 最大宽度
      data: []
    }
  ]
  private options: any = {
    color: ['#7CB8F8', '#FFD805', '#FF8A8A', '#46AE84', '#BD8DEF', '#70B603'],
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        // 坐标轴指示器，坐标轴触发有效
        type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
      }
    },
    legend: {
      data: ['已签到-在园', '已签到-出园', '未签到']
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        name: '班级',
        data: [],
        axisLabel: {
          interval: 0,
          rotate: 40
        }
      }
    ],
    yAxis: [
      {
        type: 'value',
        name: '单位：人'
      }
    ],
    series: []
  };

  /* 弹框 */
  private dialogVisible: boolean = false;
  private dialogTitle: string = '';
  private infoVisible: boolean = false;
  private infoTitle: string = '记录详情';
  private recordInfo:any = {} // 记录详情
  private curRowData:any = {} // 当前学生信息

  /* 5日缺勤学员弹框 */
  private visible: boolean = false
  private searchForm: any = {
    monthTime: Date.now()
  }
  private totalNumber: number = 0

  @Watch('staticTime', {
    immediate: true,
    deep: true
  })
  onChangeValue(newVal: string[], oldValue: string[]) {
    this.staticForm.fromThroughGateTime = newVal.length ? newVal[0] : ''
    this.staticForm.toThroughGateTime = newVal.length ? newVal[1] : ''
  }
  @Watch('recordTime', {
    immediate: true,
    deep: true
  })
  onrecordTimeChangeValue(newVal: string[], oldValue: string[]) {
    this.recordForm.fromThroughGateTime = newVal.length ? newVal[0] : ''
    this.recordForm.toThroughGateTime = newVal.length ? newVal[1] : ''
  }

  created() {
    this.getStatic()
    this.getClassList()
  }
  /**
   * 获取班级
   */
  private async getClassList() {
    const resp = await classroomAuthList({
      page: 1,
      size: 9999
    })
    this.classList = (resp as any).data.array || []
  }
  // /**
  //  * 查看弹框列表
  //  */
  // private async viewRecord(row:any) {
  //   this.curRowData = row
  //   this.dialogTitle = '生活记录'
  //   this.dialogForm = {
  //     studentId: row.studentId,
  //     recordTime: row.recordTime
  //   }
  //   this.dialogVisible = true
  // }
  // /**
  //  * 查看弹框列表
  //  */
  // private async viewInfo(row:any) {
  //   this.infoVisible = true
  //   let Info = await lifeRecordInfo({ lifeRecordId: row.lifeRecordId })
  //   this.recordInfo = Info.data
  // }
  /**
   * 导出详细数据
   */
  private async exportRecord() {
    let promise = null
    const resp = await attendanceRecordExport({
      ...this.recordForm
    })
    window.location = (resp as any).message
    return promise
  }

  /**
   * 柱状图
   */
  private getStatic() {
    attendanceStatic({
      ...this.staticForm
    })
      .then(res => {
        let arr = res.data.array || []
        if (arr.length === 0) {
          this.options.xAxis[0].data = []
          this.options.series = [];
          (this.$refs.staticChart as any).setOption(this.options)
          return
        }
        let xAxis:any = []
        this.series.map((item:any) => { item.data = [] })
        let series = [...this.series]
        arr.map((item:any, index:any) => {
          xAxis.push(item.classroomName)
          series[0].data.push(item.studentAttendanceVo.stayInSchoolSum)
          series[1].data.push(item.studentAttendanceVo.notStayInSchoolSum)
          series[2].data.push(item.studentAttendanceVo.notInSchoolSum)
        })
        this.options.xAxis[0].data = xAxis
        this.options.series = [...series]
        console.log(series);
        (this.$refs.staticChart as any).setOption(this.options)
      })
      .catch(() => {})
  }
  /**
   * 统计查询
   */
  private staticSearch() {
    this.getStatic()
  }
  private staticReset() {
    this.staticForm.classroomIds = []
    this.getStatic()
  }
  /**
   * 记录
   */
  private recordSearch() {
    (this.$refs.table as any).search()
  }
  private recordReset() {
    Object.keys(this.recordForm).forEach(key => {
      this.recordForm[key] = ''
    })
    this.recordForm.fromThroughGateTime = this.recordTime[0]
    this.recordForm.toThroughGateTime = this.recordTime[1]
    this.$nextTick(() => {
      (this.$refs.table as any).search()
    })
  }
  /**
   * 记录时间筛选
   */
  private getRecord() {
    this.recordSearch()
  }
  /**
   * 查看5日缺勤学员
   */
  private previewAbsenceStudent() {
    this.visible = true
  }
  /**
   * 导出缺勤学员
   */
  private exportAbsence() {
    let promise = null
    promise = absenceExport(this.searchForm).then(res => {
      window.location.href = (res as any).message
    }).catch(() => {})
    return promise
  }

  /**
   * 获取表格数据
   */
  private updateTableList(tableData:[]) {
    this.totalNumber = tableData.length
  }

  /**
   * 表格查询
   */
  private searchAbsenceTable() {
    (this.$refs.absenceTable as any).search()
  }
  private resetAbsenceTable() {
    this.searchForm.monthTime = Date.now()
    ;(this.$refs.absenceTable as any).search()
  }
  private close() {
    this.searchForm.monthTime = Date.now()
  }
}
